import { createFileRoute } from '@tanstack/react-router';

import { NotificationSettingsPage } from '#modules/user/features/profile/components/Settings/NotificationSettingsPage';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/notifications'
)({
  component: NotificationSettingsPage,
  ssr: false,
});
